/* eslint-disable react/prop-types */
import React from 'react';
import DatePicker from 'react-datepicker';
import ptBr from 'date-fns/locale/pt-BR';
import { withTranslation } from 'react-i18next';
import { scrollToTop } from '../../utils/smartutils';

const MonthField = ({
  input,
  placeholder,
  selected,
  disabled,
  meta: { touched, error },
}) => (
  <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
    <div className="date-field">
      <DatePicker
        disabled={disabled}
        showPopperArrow={false}
        dateFormat="MM/yyyy"
        locale={ptBr}
        selected={input.value || selected}
        onChange={input.onChange}
        placeholderText={placeholder}
        dropdownMode="scroll"
        showMonthYearPicker
        showFullMonthYearPicker
      />
    </div>
    {touched && error && (
      <span className="form__form-group-error">
        {error} {scrollToTop()}
      </span>
    )}
  </div>
);

MonthField.defaultProps = {
  disabled: false,
};

export default withTranslation('common')(MonthField);
